<template>
    <div v-if="topLevel && conditions_local" class="expressionContainer" :class="expressionContainerCollapsed_flag ? 'expressionContainerCollapsed' : 'expressionContainerExpanded'">
        <div class="expressionTextContainer" v-if="!expressionContainerCollapsed_flag">
            <div class="expressionLabel">Expression:</div>
            <div v-html="conditionalExpression" class="expressionText"></div>
        </div>
        <div class="expressionTextContainer expressionLabel" v-if="expressionContainerCollapsed_flag">
            Expand Section to View Expression Text
        </div>
        <div class="expressionStatusContainer">
            <div class="validationCheck" :class="isValid ? 'validExpression' : 'InvalidExpression'">
                <i class="fa-regular" :class="[isValid ? 'fa-circle-check' : 'fa-circle-xmark', expressionContainerCollapsed_flag ? 'validationCheckCollapsed' : 'validationCheckExpanded'] "></i>
            </div>
        </div>
        <div class="expressionContainerToggle" :class="expressionContainerCollapsed_flag ? 'expressionContainerToggleCollapsed' : 'expressionContainerToggleExpanded'"  @click="toggleExpressionContainer"></div>
    </div>
    <div class="groupContainer" v-if="conditions_local">
        <div class="groupHeaderContainer">
            <div style="display:flex;"> 
                <select style="text-transform: uppercase; padding:0px;" :value="conditionalOperator" @change="onChangeOperator($event.target.value)" v-if="showConditionalOperator() ">
                    <option value="and">and</option>
                    <option value="or">or</option>
                </select>
            </div>
            <div class="addButtonsContainer">
                <button class="actionButton addRuleButton" @click="addRule">Add Rule</button>
                <button class="actionButton addGroupButton" @click="addGroup">Add Group</button>
                <button class="deleteButton" @click="deleteGroup()" v-if="!topLevel"><i class="fas fa-trash-can"></i></button>
            </div>
        </div>
        <div class="ruleGroupContainer">
            <div v-for="(rule, index) in rules" :key="index" class="ruleContainer">
                <AutoComplete class="valueContainer" :value="getFirstValue(rule)"
                :data="attributeList" :onValueChanged="updateAutoCompleteValue"
                :onBlur="autoCompleteChanged" :placeholder="''" :passThruObject="{rule: rule, input: 'value1'}"
                internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                <select class="ruleOperator" :value="getOperator(rule)" @change="onRuleOperatorChanged(rule, $event.target.value)">
                    <option value="==">==</option>
                    <option value="!=">!=</option>
                    <option value="==">==</option>
                    <option value="&gt;=">&gt;=</option>
                    <option value="&gt;">&gt;</option>
                    <option value="&lt;=">&lt;=</option>
                    <option value="&lt;">&lt;</option>
                    <option value="in">IN LIST OF</option>
                    <option value="!">NOT IN LIST OF</option>
                </select>
                <AutoComplete class="valueContainer" :value="getSecondValue(rule)"
                :data="attributeList" :onValueChanged="updateAutoCompleteValue" 
                :onBlur="autoCompleteChanged" :placeholder="''" :passThruObject="{rule: rule, input: 'value2'}"
                internalValueField="code" displayField="code" searchField="code"></AutoComplete>
                <button class="deleteButton" @click="deleteRule(rule)"><i class="fas fa-trash-can"></i></button>
            </div>
            <ConditionGroup v-for="group in groups" :key="group.guid" :guid="group.guid" :conditions="group" 
                :attributes="attributeList" :topLevel="false" :onChanged="updateConditions"></ConditionGroup>
        </div>
        <div class="groupFooterContainer"></div>
        
    </div>
</template>

<script>
import AutoComplete from "@/components/shared/AutoComplete.vue";
import * as logicProcessing from '@/shared/logicProcessing';
import {data} from '../../../shared/data';

export default {
    name: 'ConditionGroup',
    components: { AutoComplete },
    props: {
        conditions: {},
        topLevel: {
            default: true
        },
        guid: {
            default:''
        },
        onChanged: {
            type: Function
        },
        attributes: {
            default: null
        }
    },
    data() {
        return {
            conditions_local: null,
            attributeList: [],
            expressionContainerCollapsed_flag: true,
        }
    },
    computed: {
        expressionContainerStyle() {
            return "";
        },
        conditionalExpression() {
            var expression = logicProcessing.printConditions(this.conditions_local);
            expression = expression.replaceAll("<b>AND", "<br /><b>AND");
            expression = expression.replaceAll("<b>OR", "<br /><b>OR");
            return expression;
        },
        conditionalOperator() {
            return logicProcessing.getOperator(this.conditions_local);
        },
        rules() {
            var childArray = this.conditions_local[this.conditionalOperator];
            if(childArray)
                return childArray.filter(obj => !logicProcessing.isGroupObject(obj));
            else 
                return null;
        },
        groups() {
            var childArray = this.conditions_local[this.conditionalOperator];
            if(childArray)
                return childArray.filter(obj => logicProcessing.isGroupObject(obj));
            else 
                return null;
        },
        isValid() {
            if(this.topLevel)
                return logicProcessing.validateConditions(this.conditions_local);
            else 
                return false;
        },
    },
    async mounted() {
        if(!this.attributes)
            this.attributeList = await data.getAllAttributes('', true);
        else 
            this.attributeList = this.attributes;

        if(this.topLevel && !logicProcessing.isGroupObject(this.conditions)) {
            var conditions = {'and': []};
            if(Object.keys(this.conditions).length > 0)
                conditions['and'].push(structuredClone(this.conditions));
            this.conditions_local = conditions;       
        }
        else 
            this.conditions_local =  structuredClone(this.conditions);

        this.conditions_local[this.conditionalOperator].forEach((obj) => obj.guid = logicProcessing.createGuid());

    },
    methods: {
        toggleExpressionContainer: function() {
            this.expressionContainerCollapsed_flag = !this.expressionContainerCollapsed_flag;
        },
        onChangeOperator: async function(newOperator) {
            var updatedConditions = {};
            updatedConditions[newOperator] = this.conditions_local[logicProcessing.getOperator(this.conditions_local)];
            updatedConditions.guid = this.conditions_local.guid;

            this.conditions_local = updatedConditions;

            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },
        showConditionalOperator: function() {
            var childArray = this.conditions_local[this.conditionalOperator];
            return (childArray && childArray.length > 1);
        },
        onRuleOperatorChanged: async function(rule, newOperator) {
            var updatedRule = {};
            updatedRule[newOperator] = rule[logicProcessing.getOperator(rule)];
            updatedRule.guid = rule.guid;

            if(newOperator === '!') {
                if(!updatedRule[newOperator][0]['in']) {
                    updatedRule[newOperator] = '[{"in":' + JSON.stringify(updatedRule[newOperator]) + '}]';
                    updatedRule[newOperator] = JSON.parse(updatedRule[newOperator]);
                }
            } else if(logicProcessing.getOperator(rule) === '!'){
                if(updatedRule[newOperator][0]['in']) {
                    updatedRule[newOperator] = updatedRule[newOperator][0]['in'];
                }
            }

            var childArray = this.conditions_local[this.conditionalOperator];
            var index = childArray.findIndex(obj => obj.guid === rule.guid);
            if(index < 0) return; 
            
            childArray[index] = updatedRule;
            
            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },
        getFirstValue: function(object) {
           return logicProcessing.getFirstValue(object, 0);                 
        },
        getSecondValue: function(object) {
           return logicProcessing.getSecondValue(object, 1);                 
        },
        getOperator: function(object) {
            return logicProcessing.getOperator(object).toLowerCase();
        },
        addRule: function() {
            this.addToConditions({"==": [{"var": ""}, ""], "guid": logicProcessing.createGuid()});
        },
        addGroup: function() {
            this.addToConditions({"and": [], "guid": logicProcessing.createGuid()});
        },
        addToConditions(object) {
            var childArray = this.conditions_local[this.conditionalOperator];
            if(!childArray)
                childArray = [];

            childArray.push(object)

            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },
        deleteRule: function(rule) {
            var childArray = this.conditions_local[this.conditionalOperator];
            const index = childArray.indexOf(rule);
            if(index >= 0)
                childArray.splice(index, 1);         

            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },
        deleteGroup: function() {
            this.conditions_local = {};
            this.checkToEmitIsChanged(this.guid,null);
        },
        updateAutoCompleteValue(refObj, newValue) {
            var index = Number(refObj.input.replace("value", "")) - 1;
            let attrBool = this.attributeList.findIndex(obj => obj.code === newValue || (obj.code + '_VALUE') === newValue || (obj.code + '_LABEL') === newValue) >= 0;
            logicProcessing.setValue(refObj.rule, index, newValue, attrBool);              
        },
        autoCompleteChanged: async function(refObj, newValue) {
            this.updateAutoCompleteValue(refObj, newValue);
            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },    
        updateConditions: function(guid, conditionGroup) {
            var childArray = this.conditions_local[this.conditionalOperator];
            if(!childArray) return;
       
            var index = childArray.findIndex((obj) => obj.guid === guid );
            if(index < 0) return;

            if(conditionGroup == null) {
                childArray.splice(index, 1);
            }
            else 
                childArray[index] = conditionGroup;
            
            this.checkToEmitIsChanged(this.guid, this.conditions_local);
        },
        checkToEmitIsChanged(guid, conditionGroup) {
            if(this.topLevel) {
                if(this.isValid && this.onChanged) {
                    var conditions_minus_guids = logicProcessing.removeGuidsFromConditions(structuredClone(this.conditions_local));
                    var childArray = conditions_minus_guids[logicProcessing.getOperator(conditions_minus_guids)];
                    if(childArray.length == 0) delete conditions_minus_guids[logicProcessing.getOperator(conditions_minus_guids)];

                    this.onChanged(logicProcessing.formatNotInConditions(conditions_minus_guids));
                }
            }
            else if(this.onChanged)
                this.onChanged(guid, logicProcessing.formatNotInConditions(conditionGroup));
        }
    }
}
</script>

<style scoped>
    select {
        border-radius: 4px;
    }
    
    .groupContainer {
        border: solid 1px black;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .ruleGroupContainer {
        padding: 10px 20px;
    }

    .ruleContainer { 
        display: flex; 
        flex-direction: row;
        margin: 5px 0px;
    }
    .groupHeaderContainer { 
        background-color: #F3F3F3;
        padding: 10px 50px 10px 10px;
        border-bottom: solid 1px black;
        display:flex; 
        flex-direction: row;
    }

    .groupFooterContainer { 
        background-color: #F3F3F3;
        padding: 10px 50px 10px 10px;
        border-top: solid 1px black;
    }

    .addButtonsContainer {
        display:flex; 
        flex-direction: row;
        justify-content: flex-end;
        width: 100%;
    }

    .actionButton {
        padding: 3px 5px;
        color: white;
        opacity: 0.8;
        border: 1px solid #000000;
        border-radius: 3px;
        cursor: pointer;
        font-size: 13px;
    }

    .addRuleButton {
        background-color: #3246FF;
        border-color: #3246FF;
    }

    .addGroupButton {
        margin-left: 10px;
        background-color: #545454;
        border-color: #545454;
    }

    .valueContainer {
        display: flex;
    }

    .valueContainer input {
        padding: 2px 5px;

    }

    select.ruleOperator {
        margin: 0px 10px;
    }

    .deleteButton {
        font-size: 13px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 20px;
    }

    .popupConfiguration .flexColumn, .popupConfiguration .flexRow {
        width: 100%;
    }
    .popupConfiguration div.flexRow {
        margin: 10px 0;
    }
    .popupConfiguration p {
        flex: 0 0 167px;
    }

    .popupConfiguration textarea {
        flex: 1 1 300px;
        min-height: 100px;
    }

    .popupConfiguration input, .popupConfiguration select {
        flex: 0 1 300px;
    }

    .expressionTextContainer {
        overflow: hidden;
    }

    .expressionLabel {
        font-weight: bold;
    }

    .expressionContainer {
        background-color: #CDDDDD;
        margin: 10px 30px;
        padding: 10px 30px;
        display: flex;
        text-align: left;
        justify-content: space-between;
        position: relative;
    }

    .expressionContainerCollapsed {
        height: 25px;
        overflow: hidden;
    }

    .expressionContainerExpanded {
        max-height: unset;
    }

    .expressionContainerToggleCollapsed:before  {
        content: "\f0d7";
    }

    .expressionContainerToggleExpanded:before {
        content: "\f0d8";
    }

    .expressionContainerToggle {
        cursor: pointer;
        position: absolute;
        bottom: -3px;
        left: 50%;
    }

    .expressionContainerToggle:before {
        font-family: FontAwesome;
    }

    .expressionStatusContainer {
        display: flex;
        align-items: center;
    }


    .validExpression{
        color: green;
    }

    .InvalidExpression {
        color: red;
    }

    .validationCheck {
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 15px;
    }

    .validationCheckCollapsed {
        font-size: 3cqh;
    }
    
    .validationCheckExpanded {
        font-size: 7cqh;
    }

    div.expressionText :deep(.level0) {
        color: black;
    }

    div.expressionText :deep(.level1) {
        color: orange;
    }

    div.expressionText :deep(.level2) {
        color: blue;
    }

    div.expressionText :deep(.level3) {
        color: brown;
    }

    div.expressionText :deep(.indent) {
        margin-left: 10px;
    }

    :deep(input[type='text']) {
        font-size: smaller;
    }

    :deep(select) {
        padding: 0px;
        font-size: smaller;
    }
</style>